import router from '@/router'
import { executeDataUpdate } from '@/modules/offlineDataUpload/indexedDbSync'
import * as indexedDB from '@/accessors/indexedDB/common/indexedDBController'
import type { IndexedDBData } from '@/types/accessor/indexedDB/indexedDB'
import { useLoadingView } from '@/modules/miiaFw/composables/useLoadingView'
import { ROUTER_PATHS } from '@/constants/router/paths'
import { useCommonModalStore } from '@/stores/commonModalStore'
import { MODAL_RESULT, type ModalResult } from '../miiaFw/types/components/commonModal'
import { STORE_NAME as INSPECTION_RESULT_IDB_STORE_NAME } from '@/accessors/indexedDB/disasterEmergencyInspectionResultIdb'
import { SEND_STATE } from '@/constants/accessor/indexedDB/indexedDB'

const loadingView = useLoadingView()

/**
 * オフラインデータの一括反映プロセス
 * @param なし
 * @returns なし
 */
export const offlineDataUpdateProcessHandler = async (): Promise<void> => {
  const commonModalStore = useCommonModalStore()
  const loadingMessage =
    'データ反映中です。件数が多い場合、時間がかかる場合があります。このままお待ちください。'
  loadingView.setLoadingView(true, loadingMessage)

  const result = await executeDataUpdate()

  if (result !== 0) {
    commonModalStore
      .openConfirmModal({
        title: '処理中に異常が発生しました',
        body: `処理中に異常が発生しました。
                <br>再アップロードしますか？
                <br>※アップロードしない場合、前日分の未反映データは破棄されます。
                <br>※何度も発生する場合は管理者に連絡ください。`,
        okTitle: 'はい',
        cancelTitle: 'いいえ'
      })
      .then(async (result: ModalResult) => {
        if (result === MODAL_RESULT.OK) {
          // オフラインデータの一括反映プロセスを再実行
          await offlineDataUpdateProcessHandler()
        }
      })
      .catch(async (result: ModalResult) => {
        if (result === MODAL_RESULT.CANCEL) {
          // ホーム画面へ遷移
          void router.push(ROUTER_PATHS.home).catch(() => {})
        }
      })
  } else {
    commonModalStore
      .openAlertModal({
        title: '正常に処理が完了しました',
        body: 'データの反映が完了しました。',
        okTitle: '閉じる'
      })
      .then(() => {
        // ホーム画面へ遷移
        void router.push(ROUTER_PATHS.home).catch(() => {})
      })
  }

  loadingView.setLoadingView(false)
}

/**
 * アップロード処理が必要かの確認
 * @param なし
 * @returns 処理要否（true: 必要, false: 不要）
 */
export const isRequireDataUpdate = async (): Promise<boolean> => {
  try {
    const dataKeys = await indexedDB.getAllKeys(INSPECTION_RESULT_IDB_STORE_NAME)
    for (const key of dataKeys) {
      const data = (await indexedDB.get(INSPECTION_RESULT_IDB_STORE_NAME, key)) as IndexedDBData
      if (data === undefined) return false
      if (data.send_state === SEND_STATE.EDITED) {
        return true
      }
    }
  } catch (e) {
    console.error(e)
  }
  return false
}
